module.exports = __webpack_public_path__ + "img/eg-other-01.64d90a83.png";